import { MassUnit, MetricToImperialConverter } from 'fitbeat.models';
import React, { useEffect } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { formValueSelector, isInvalid, reduxForm } from 'redux-form';
import { Button, ButtonSize, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { WeightField } from '../../ui/components/form';
import { UserDataConsumer } from '../../utils/';
import { defaultScale } from '../../utils/scaling';
import { WeightTargetHeader } from './weight-target-header';

const WeightTargetReviewComponent = ({
    t, initialize, user: { userProfile },
    goToPreviousStep, goToNextStep, handleSubmit, isProcessing, formHasErrors }) => {
    useEffect(() => {
        let weight = userProfile.weight;
        if (userProfile.useImperialUnit) {
            weight = MetricToImperialConverter.convertWeightToImperial(weight);
        }
        initialize({
            weight: `${Math.round(weight * 100) / 100}`,
        });
    }, []);

    const submitAndGoNext = (values) => {
        const parsedWeight = parseFloat(values.weight.replace(',', '.'));
        const metricWeight = userProfile.useImperialUnit ?
            MetricToImperialConverter.convertAmount(MassUnit.Pound, MassUnit.Killogram, parsedWeight) :
            parsedWeight;
        goToNextStep(metricWeight);
    };

    return <View>
        <WeightTargetHeader
            title={t('reviewCurrentWeight')}
            subTitle={t('reviewWeightDescription')}
            goToPreviousStep={goToPreviousStep} />
        <View>
            <View>
                <Text style={styles.label}>{t('yourCurrentWeight')}</Text>
                <WeightField
                    hasPlaceholder={false}
                    useImperialUnit={userProfile.useImperialUnit}
                    autoFocus={false}
                    onSubmitEditing={handleSubmit(submitAndGoNext)}
                />
            </View>
            <Button
                title={t('next')}
                onPress={handleSubmit(submitAndGoNext)}
                fontColor={Theme.WHITE}
                buttonType={ButtonTypes.NORMAL}
                size={ButtonSize.NORMAL}
                isLoading={isProcessing}
                disabled={formHasErrors}
                containerStyle={{ marginTop: defaultScale(10) }}
            />
        </View>
    </View>;
};

const styles = StyleSheet.create({
    label: {
        ...Theme.textStyle.small,
        color: Theme.GREY_MEDIUM,
    },
});

const selector = formValueSelector('weightReviewForm');
const mapStateToProps = (state) => {
    const weightValue = selector(state, 'weight');
    return {
        weightValue,
        formHasErrors: isInvalid('weightReviewForm')(state),
    };
};

export const WeightTargetReview = reduxForm({ form: 'weightReviewForm' })(
    translate(['weightTarget'], { wait: true })(
        UserDataConsumer(connect(mapStateToProps)(WeightTargetReviewComponent))),
);
